<template>
    <div>
        <template v-if=" type === 'phone_1' ">
            <ForceNewsBlockWrapper :requireCharacters="requireCharacters"
                                   :titleLabel="$t('profile.label.phone_number')"
                                   :parentScreen="parentScreen">
                <div class="form-group row">
                    <label class="control-label col-md-3 col-form-label" for="phone">
                        {{$t('profile.label.phone_number')}}
                    </label>
                    <div class="col-md-6">
                        <input
                                type="text"
                                class="form-control"
                                :value="$v.input['amsCustomerDetail.phone'].$model"
                                id="phone"
                                name="phone"
                                required
                                maxlength="11"
                                v-numbers-only
                                v-convert-fullwidth-to-halfwidth
                                @input="e => $v.input['amsCustomerDetail.phone'].$model = e.target.value"
                                @keyup="handleForceNewEvent"
                        >
                        <error-messages-block :field="$v.input['amsCustomerDetail.phone']">
                            <template #required>
                                {{ $t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.phone_number')}) }}
                            </template>
                            <template #phoneNumberValidation>
                                {{ $t('profile.update.error.phone.invalid') }}
                            </template>
                        </error-messages-block>
                    </div>
                </div>
                <template v-if="parentScreen === 'edit-profile'">
                    <div class="form-action">
                        <button class="btn btn-sm btn-submit btn-success mr-2"
                                :disabled="isDisabledButtonSubmit"
                                :type="this.getButtonType()">
                            {{$t('profile.button.submit')}}
                        </button>
                        <button class="btn btn-default btn-cancel btn-sm"
                                type="button"
                                @click="reverseInput">
                            {{$t('profile.button.cancel')}}
                        </button>
                    </div>
                </template>
            </ForceNewsBlockWrapper>
        </template>
        <template v-if=" type === 'phone_2' ">
            <ForceNewsBlockWrapper :requireCharacters="requireCharacters" :titleLabel="$t('profile.label.phone_number2')" :parentScreen="parentScreen">
                <div class="form-group row">
                    <label class="control-label col-md-3 col-form-label" for="phone">
                        {{$t('profile.label.phone_number2')}}
                    </label>
                    <div class="col-md-6">
                        <input
                                type="text"
                                class="form-control"
                                :value="$v.input['amsCustomerDetail.phone2'].$model"
                                id="phone2"
                                name="phone2"
                                maxlength="11"
                                v-numbers-only
                                v-convert-fullwidth-to-halfwidth
                                @input="e => $v.input['amsCustomerDetail.phone2'].$model = e.target.value"
                                @keyup="handleForceNewEvent"
                        >
                        <error-messages-block :field="$v.input['amsCustomerDetail.phone2']">
                            <template #phoneNumberValidation>
                                {{ $t('profile.update.error.phone.invalid') }}
                            </template>
                        </error-messages-block>
                    </div>
                </div>
                <template v-if="this.isParentScreenEditProfile">
                    <div class="form-action">
                        <button class="btn btn-sm btn-submit btn-success mr-2"
                                :disabled="isDisabledButtonPhone2"
                                :type="this.getButtonType()">
                            {{$t('profile.button.submit')}}
                        </button>
                        <button class="btn btn-default btn-cancel btn-sm"
                                type="button"
                                @click="reverseInput">
                            {{$t('profile.button.cancel')}}
                        </button>
                    </div>
                </template>
            </ForceNewsBlockWrapper>
        </template>
    </div>
</template>
<script>
    /**
     * @author HungNS
     */
    import formMixin from '@/common/mixins/form';
    import forceNewUtil from "@/common/mixins/forceNewUtil";
    import {required} from 'vuelidate/lib/validators'
    import {phoneNumberValidation} from '@/common/helpers/validation'

    export default {
        name: "UpdatePhone",
        props: {
            type: {
                required: false,
                type: String,
                default: 'phone_1'
            }
        },
        mixins: [formMixin, forceNewUtil],
        computed: {
            isDisabledButtonPhone2() {
                const {$v} = this;
                return $v.$anyError || !$v.$dirty;
            },
        },
        validations() {
            const key = this.type === "phone_1" ? "amsCustomerDetail.phone" : "amsCustomerDetail.phone2";
            if (key === "amsCustomerDetail.phone"){
                return {
                    input: {
                        [key]: {
                            required,
                            phoneNumberValidation
                        }
                    }
                }
            } else {
                return {
                    input: {
                        [key]: {
                            phoneNumberValidation
                        }
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
